/**
 * Keyboard helpers for accessible form submission.
 */

/** Stops Enter from bubbling to a parent form (multiline fields keep their default newline). */
export function stopEnterPropagation(event: KeyboardEvent): void {
    if (event.key !== "Enter" || event.shiftKey || event.ctrlKey || event.metaKey || event.altKey) {
        return;
    }
    event.stopPropagation();
}

/**
 * Triggers the primary confirm action when Enter is pressed in a modal,
 * unless focus is already on an interactive control that handles Enter itself.
 */
export function handleModalConfirmKey(event: KeyboardEvent, confirm: () => void): void {
    if (event.key !== "Enter" || event.shiftKey || event.ctrlKey || event.metaKey || event.altKey) {
        return;
    }

    const target = event.target;
    if (!(target instanceof HTMLElement)) {
        return;
    }

    const tag = target.tagName;
    if (tag === "TEXTAREA" || tag === "SELECT") {
        return;
    }
    if (tag === "INPUT") {
        const inputType = (target as HTMLInputElement).type;
        if (inputType !== "button" && inputType !== "submit" && inputType !== "reset") {
            return;
        }
    }
    if (tag === "BUTTON" || tag === "A") {
        return;
    }

    event.preventDefault();
    confirm();
}
